import React, { useEffect, useState } from "react";
import filter from "../../../images/filter.svg";
import edit from "../../../images/edit.svg";
import search from "../../../images/search.svg";
import {
  changeNumberFormat,
  downloadDocument,
  filterByValue,
} from "../../../utils/CommonMethods";
import { compareTime, FormatDate } from "../../../utils/DateFormat";
import { formatTime } from "../../../utils/DateFormat";
import MultiSelect from "../../common/controls/MultiSelect";
import Calendar from "../../common/controls/Calendar";
import ConfirmationDialog from "../../common/controls/ConfirmationDialog";
import { get, post } from "../../../effects/api/api.common";
import {
  DOWNLOAD_EXCEL,
  GET_ALL_SECTOR,
  GET_ALL_STATES,
  GET_STARTUP_APPLICATION_STATUS,
  GET_STARTUP_ENGAGEMENT_STATUS,
  GET_STARTUP_LISTING,
  GET_STARTUP_LISTING_FILTER,
  STARTUP_SCHEDULE_MEETING,
  STORE_STARTUP_APPLICATION,
} from "../../../constants/api";
import { useHistory } from "react-router-dom";
import { DropdownModel } from "../../../models/DropdownModel";
import { isTemplateExpression } from "typescript";
import moment from "moment";
import { getSessionStorageValue } from "../../../effects/utils/session-storage";
interface IStartupListProps {}

interface IStartupListState {}

function StartupListContainer(props: any) {
  var currentdatenew = moment().format("YYYY-MM-DD")
  const history = useHistory();
  const [isChecked, setIsChecked] = useState(false);
  const [meetingLink, setMeetingLink] = useState("");
  const [showEditTranche, setShowEditTranche] = useState(false);
  const [showIncubatorFailureModal, setShowIncubatorFailureModal] =
    useState(false);
  const [timeValidation, setTimeValidation] = useState(false);
  const [linkValidation, setLinkValidation] = useState(false);
  const [showPreference, setShowPreference] = useState(true);
  const [timeValidationCurrentTime, setTimeValidationCurrentTime] =
    useState(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [checkBoxHide, setCheckBoxHide] = useState(true);
  const [showEditFailureModal, setShowEditFailureModal] = useState(false);
  const [showEditSuccessModal, setShowEditSuccessModal] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState([]);
  const [engagementStatus, setEngagementStatus] = useState([]);
  const [selectFlag, setSelectFlag] = useState(true);
  const [rejectedFlag, setRejectedFlag] = useState(true);
  const [showIncubatorSuccessModal, setShowIncubatorSuccessModal] =
    useState(false);
  const [countryStates, setCountryStates] = useState([]);
  const [sectorDetails, setSectorDetails] = useState([]);
  const [entityDetails, setEntityDetails] = useState([]);
  const [isDisabled, setDisabled] = useState(false);
  const [showConfirmationBox, setShowConfirmationBox] = useState(false);
  const [oneStartupCheckbox, setOneStartup] = useState(false);
  const [columnHideFlag, setColumnHideFlag] = useState(true);
  const [tableHeading, setTableHeading] = useState("Applications Submitted");
  const [noStartupCheckbox, setNoStartup] = useState(false);
  const [selectedStateValue, setStateValue] = useState<Array<string>>([]);
  const [selectedSectorValue, setSectorValue] = useState<Array<string>>([]);
  const [fundingType, setFundingType] = useState("");
  const [filterDate, setFilterDate] = useState("");
  // const [selectedEntityValue, setEntityValue] = useState<Array<string>>([]);
  const [checkedArray, setCheckedArray] = useState<Array<string>>([]);
  const [fromTime, setFromTime] = useState(String);
  const [toTime, setToTime] = useState(String);
  const [incubatorMeetingType, setincubatorMeetingType] = useState("1");
  const [scheduleDate, setScheduleDate] = useState(String);
  const [selectedDateControl, setSelectedDateControl] = useState(new Date());
  const [activeIndex, setActiveIndex] = useState<any>(["2"]);
  const [mouseOverFlag, setMouseOverFlag] = useState("");
  const [quickEditPopupData, setquickEditPopupData] = useState({
    application_comments: "",
    application_id: "",
    application_status: "",
    engagement_status: "",
    corporate_id_no: "",
    incubator_name: "",
    no_of_tranches: "",
    date_of_evaluation: "",
    total_approved_amount: "",
  });
  const [incubatorListingCounts, setIncubatorListingCounts] = useState({
    incomplete: "0",
    onHold: "0",
    pendingReview: "0",
    rejected: "0",
    selected: "0",
    submitted: "0",
    reviewCount: "0",
    trancheRequest: "0",
    closed: "0",
    cancel:'0',
    cancelled: "0",
  });
  const [incubatorList, setincubatorList] = useState<Array<any>>([]);
  const [showFilterDot, setShowFilterDot] = useState(false);
  const [filteredIncubatorList, setFilteredIncubatorList] = useState([
    {
      id: "",
      application_date: "",
      government_assisted: "",
      state_name: "",
      incubator_name: "",
      total_approved_amount: "",
      total_disbursed_amt: "",
      meeting_date: "",
      meeting_time: "",
      meeting_id: "",
      meeting_status: "",
      status_id: "",
      startup_status_id: "",
    },
  ]);
  const [incubatorListCountHead, setincubatorListCountHead] = useState("");
  const [incubatorListId, setIncubatorListId] = useState({
    incomplete_id: "",
    onHold_id: "",
    pendingReview_id: "",
    rejected_id: "",
    selected_id: "",
    submitted_id: "",
    trancheRequest_id: "",
    closed_id: "",
    cancelled_id: "",
  });

  const [dialogData, setDialogData] = useState({
    header: "",
    text: "",
  });
  const [failDialogData, setFailDialogData] = useState({
    header: "",
    text: "",
  });
  const [confirmationDialogData, setConfirmationDialogData] = useState({
    header: "",
    text: "",
  });
  const [loggedInRole, setLoggedInRole] = useState("");
  const [incubatorUserId, setIncubatorUserId] = useState("");
  const [Cancellation_Requested_Count, setCancellation_Requested_Count] = useState<any>("");
  const [Cancellation_Approved_Count, setCancellation_Approved_Count] = useState<any>("");
  const [Tranche_Requested_Count, setTranche_Requested_Count] = useState<any>("");
  const [currentdate,setCurrentdate]=useState("")
  useEffect(() => {
    
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user);
    setLoggedInRole(userInfo.roles);
    //console.log(typeof props.location.state !== "undefined","data$$$$")
    //console.log(props.location.state !=null,"data$$$$")
    //console.log( typeof props.location.state !== "undefined" && props.location.state != null,"data$$$$")
  

    if (
      typeof props.location.state !== "undefined" &&
      props.location.state != null
    ) {
      window.scrollTo(0, 0);
      getAllStates();
      getRestrictedIncubatorCount(props.location.state.user_id);
      setIncubatorUserId(props.location.state.user_id);
      if (typeof props.location.state.showPreference != "undefined") {
        setShowPreference(props.location.state.showPreference);
      }
      getAllSectors();
    } else {
      //console.log("getttt")
      window.scrollTo(0, 0);
      getAllStates();
      getIncubatorCount();
      getAllSectors();
    }
    
    // getDataByStatus("2")

    // getAllLegalEntity();
    // function convert(d:any) {
    //   var date = new Date(),
    //     mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //     day = ("0" + date.getDate()).slice(-2);
    //   return [date.getFullYear(), mnth, day].join("-");
    // }
    // const d = new Date();
    // const frmtD = convert(d)
    // //console.log(d)
    // setCurrentdate(frmtD)
  }, []);
  
  const getRestrictedIncubatorCount = (id: any) => {
    //console.log(id,"idddd")
    setCheckBoxHide(true);
    setButtonDisable(true);
    post(GET_STARTUP_LISTING, {
      list_from: "incubator",
      incubator_id: id,
      status_id: [2],
      intial_call:'yes',
    }).then((response: any) => {
      if (!response || !response.data) return;
      const counts = {
        incomplete: "0",
        onHold: "0",
        pendingReview: "0",
        rejected: "0",
        selected: "0",
        submitted: "0",
        reviewCount: response.data.reviewCount
          ? response.data.reviewCount
          : "0",
        trancheRequest: response.data.tranceRequestedCount,
        closed: "0",
        cancel:response.data.cancellationRequestedCount,
        cancelled: response.data.cancellationApprovedCount,
      };
      const status_id = {
        incomplete_id: "",
        onHold_id: "",
        pendingReview_id: "",
        rejected_id: "",
        selected_id: "",
        submitted_id: "",
        trancheRequest_id: "",
        closed_id: "",
        cancelled_id: "",
      };
      for (var i = 0; i < response.data.mainCount.length; i++) {
        if (response.data.mainCount[i].name == "incomplete") {
          counts.incomplete = response.data.mainCount[i].appln_count;
          status_id.incomplete_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "pending_review") {
          counts.pendingReview = response.data.mainCount[i].appln_count;
          status_id.pendingReview_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "submitted") {
          counts.submitted = response.data.mainCount[i].appln_count;
          status_id.submitted_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "on_hold") {
          counts.onHold = response.data.mainCount[i].appln_count;
          status_id.onHold_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "rejected") {
          counts.rejected = response.data.mainCount[i].appln_count;
          status_id.rejected_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "selected") {
          counts.selected = response.data.mainCount[i].appln_count;
          status_id.selected_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "closed") {
          counts.closed = response.data.mainCount[i].appln_count;
          status_id.closed_id = response.data.mainCount[i].id;
        }else if (response.data.mainCount[i].name == "cancelled") {
          // counts.cancelled = response.data.mainCount[i].appln_count;
          // status_id.closed_id = response.data.mainCount[i].id;
        }
      }
   //console.log(response.data.cancellationRequestedCount,"data$$$$$")
   //console.log(response.data.tranceRequestedCount,"data$$$$$")
   setCancellation_Requested_Count(response.data.cancellationRequestedCount);
   setCancellation_Approved_Count(response.data.cancellationApprovedCount);

   //console.log(response.data.tranceRequestedCount,"tranceRequestedCount")
   setTranche_Requested_Count(response.data.tranceRequestedCount);
      setIncubatorListingCounts(counts);
      // console.log(counts,"hello")
      setIncubatorListId(status_id);
      setincubatorListCountHead(response.data.applications.length);
      if (response.data.applications.length != 0) {
       //console.log(response.data.applications,"sri@@")
        setincubatorList(response.data.applications);
        
        setFilteredIncubatorList([]);

        setColumnHideFlag(false);
        // setincubatorList(incubatorListData);
      } else {
        setincubatorList([]);
      }
    });
  };

  // get initial count of incubators
  const getIncubatorCount = () => {
    //console.log("hello")
    setCheckBoxHide(true);
    setButtonDisable(true);
    post(GET_STARTUP_LISTING, { status_id: [2], intial_call:'yes'}).then((response: any) => {
      setCancellation_Requested_Count(response.data.cancellationRequestedCount);
      setCancellation_Approved_Count(response.data.cancellationApprovedCount);

      //console.log(response.data.tranceRequestedCount,"tranceRequestedCount")
      setTranche_Requested_Count(response.data.tranceRequestedCount);
      if (!response || !response.data) return;
      const counts = {
        incomplete: "0",
        onHold: "0",
        pendingReview: "0",
        rejected: "0",
        selected: "0",
        submitted: "0",
        reviewCount: response.data.reviewCount
          ? response.data.reviewCount
          : "0",
        trancheRequest: response.data.tranceRequestedCount,
        closed: "0",
        cancel:response.data.cancellationRequestedCount,
        cancelled: response.data.cancellationApprovedCount,
      };
      const status_id = {
        incomplete_id: "",
        onHold_id: "",
        pendingReview_id: "",
        rejected_id: "",
        selected_id: "",
        submitted_id: "",
        trancheRequest_id: "",
        closed_id: "",
        cancelled_id: "",
      };
      for (var i = 0; i < response.data.mainCount.length; i++) {
        if (response.data.mainCount[i].name == "incomplete") {
          counts.incomplete = response.data.mainCount[i].appln_count;
          status_id.incomplete_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "pending_review") {
          counts.pendingReview = response.data.mainCount[i].appln_count;
          status_id.pendingReview_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "submitted") {
          counts.submitted = response.data.mainCount[i].appln_count;
          status_id.submitted_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "on_hold") {
          counts.onHold = response.data.mainCount[i].appln_count;
          status_id.onHold_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "rejected") {
          counts.rejected = response.data.mainCount[i].appln_count;
          status_id.rejected_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "selected") {
          counts.selected = response.data.mainCount[i].appln_count;
          status_id.selected_id = response.data.mainCount[i].id;
        } else if (response.data.mainCount[i].name == "closed") {
          counts.closed = response.data.mainCount[i].appln_count;
          status_id.closed_id = response.data.mainCount[i].id;
        }
      }

      setIncubatorListingCounts(counts);
      setIncubatorListId(status_id);
      setincubatorListCountHead(response.data.applications.length);
      if (response.data.applications.length != 0) {
        setincubatorList(response.data.applications);
        setFilteredIncubatorList([]);

        setColumnHideFlag(false);
        // setincubatorList(incubatorListData);
      } else {
        setincubatorList([]);
      }
    });
  };

  // get states in dropdown
  const getAllStates = () => {
    get(GET_ALL_STATES).then((response: any) => {
      if (!response || !response.data) return;
      const states = response.data.data.map((item: any): DropdownModel => {
        return {
          text: item.name,
          id: item.id.toString(),
          translation_text: "",
        };
      });
      setCountryStates(states);
    });
  };

  const searchList = (e: any) => {
    const filteredData = filterByValue(incubatorList, e.target.value);
    setincubatorListCountHead(filteredData.length.toString());
    setFilteredIncubatorList(filteredData);
  };

  // get all sectors in dropdown
  const getAllSectors = () => {
    get(GET_ALL_SECTOR).then((response: any) => {
      if (!response || !response.data) return;
      const sectors = response.data.data.map((item: any): DropdownModel => {
        return {
          text: item.attribute_value,
          id: item.id.toString(),
          translation_text: "",
        };
      });
      setSectorDetails(sectors);
    });
  };


  const getDataByStatus = (selected_id: any) => {
    //console.log(selected_id,"selected_id")
    if (loggedInRole == "secretariat" || loggedInRole == "dpiit") {
      if (selected_id == "2") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Submitted");
        setincubatorListCountHead(incubatorListingCounts.submitted);
      } else if (selected_id == "3") {
        setincubatorMeetingType("1");
        setButtonDisable(false);
        setCheckBoxHide(false);
        setCheckedArray([]);
        setTableHeading("Applications to be Reviewed");
        setincubatorListCountHead(incubatorListingCounts.pendingReview);
      } else if (selected_id == "4") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Incomplete");
        setincubatorListCountHead(incubatorListingCounts.incomplete);
      } else if (selected_id == "5") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications On Hold");
        setincubatorListCountHead(incubatorListingCounts.onHold);
      } else if (selected_id == "6") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Rejected");
        setincubatorListCountHead(incubatorListingCounts.rejected);
      } else if (selected_id == "7") {
        setincubatorMeetingType("2");
        setButtonDisable(false);
        setCheckBoxHide(false);
        setCheckedArray([]);
        setTableHeading("Applications Selected");
        setincubatorListCountHead(incubatorListingCounts.selected);
      } else if (selected_id == "8") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Closed");
        setincubatorListCountHead(incubatorListingCounts.closed);
      } else if (selected_id == "tranche") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Tranche Requested");
        setincubatorListCountHead(incubatorListingCounts.trancheRequest);
      } else if (selected_id == "cancelled") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Cancelled");
        setincubatorListCountHead(incubatorListingCounts.cancelled);
      }
      else if (selected_id == "cancel") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Cancellation Requested");
        setincubatorListCountHead(incubatorListingCounts.cancel);
      }
      setActiveIndex(selected_id);
      setincubatorList([]);
      var payload = {};
      if (selected_id == "tranche") {
        payload = {
          tranche_requested: "Yes",
          list_from: "incubator",
          incubator_id: incubatorUserId,
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      } else if (selected_id == "cancel") {
        payload = {
          cancellation_requested: "Yes",
          list_from: "incubator",
          incubator_id: incubatorUserId,
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      } else if (selected_id == "cancelled") {
        payload = {
          cancellation_approved: "yes",
          list_from: "incubator",
          incubator_id: incubatorUserId,
         
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          
        };
      } else {
        payload = {
          status_id: selected_id,
          list_from: "incubator",
          incubator_id: incubatorUserId,
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      }
      post(GET_STARTUP_LISTING, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.applications.length != 0) {
          setincubatorList(response.data.applications);

          setFilteredIncubatorList([]);
          if (
            selected_id == "7" ||
            selected_id == "8" ||
            selected_id == "tranche"
          ) {
            setColumnHideFlag(true);
          } else {
            setColumnHideFlag(false);
          }
        } else {
          setincubatorList([]);
        }
      });
    } else {
      //console.log(selected_id,"incubator sri@@")

      if (selected_id == "2") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Submitted");
        setincubatorListCountHead(incubatorListingCounts.submitted);
      } else if (selected_id == "3") {
        setincubatorMeetingType("1");
        setButtonDisable(false);
        setCheckBoxHide(false);
        setCheckedArray([]);
        setTableHeading("Applications to be Reviewed");
        setincubatorListCountHead(incubatorListingCounts.pendingReview);
      } else if (selected_id == "4") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Incomplete");
        setincubatorListCountHead(incubatorListingCounts.incomplete);
      } else if (selected_id == "5") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications On Hold");
        setincubatorListCountHead(incubatorListingCounts.onHold);
      } else if (selected_id == "6") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Rejected");
        setincubatorListCountHead(incubatorListingCounts.rejected);
      } else if (selected_id == "7") {
        setincubatorMeetingType("2");
        setButtonDisable(false);
        setCheckBoxHide(false);
        setCheckedArray([]);
        setTableHeading("Applications Selected");
        setincubatorListCountHead(incubatorListingCounts.selected);
      } else if (selected_id == "8") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Closed");
        setincubatorListCountHead(incubatorListingCounts.closed);
      } else if (selected_id == "tranche") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Tranche Requested");
        setincubatorListCountHead(incubatorListingCounts.trancheRequest);
      } else if (selected_id == "cancelled") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Applications Cancelled");
        setincubatorListCountHead(incubatorListingCounts.cancelled);
      }else if (selected_id == "cancel") {
        setIsChecked(false);
        setButtonDisable(true);
        setCheckBoxHide(true);
        setTableHeading("Cancellation Requested");
        setincubatorListCountHead(incubatorListingCounts.cancel);
      }
      setActiveIndex(selected_id);
      setincubatorList([]);
      var payload = {};
      if (selected_id == "tranche") {
        payload = {
          tranche_requested: "Yes",
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      } else if (selected_id == "cancelled") {
        payload = {
          cancellation_approved: "yes",        
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id: selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,         
        };
      } else if (selected_id == "cancel") {
        payload = {
          cancellation_requested: "Yes",
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      } else {
        payload = {
          status_id: selected_id,
          // leagel_entity_id:
          //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
          // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
          // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
        };
      }
      post(GET_STARTUP_LISTING, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.applications.length != 0) {
          //console.log(response.data.applications,"@@")
          // //console.log(response.data.applications[0].recognition_number,"$$")

          // //console.log(response.data.applications[0].evaluation_to_be_completed_by < currentdate,response.data.applications[0].startup_status_id, response.data.applications[0].startup_status_id)

          // //console.log(response.data.applications[0].evaluation_to_be_completed_by < currentdate,response.data.applications[0].startup_status_id !== 6 , response.data.applications[0].startup_status_id !== 7)
          setincubatorList(response.data.applications);
    
          setFilteredIncubatorList([]);
          if (
            selected_id == "7" ||
            selected_id == "8" ||
            selected_id == "tranche"
          ) {
            setColumnHideFlag(true);
          } else {
            setColumnHideFlag(false);
          }
        } else {
          setincubatorList([]);
        }
      });
    }
  };
  const mouseOverEvent = (id: any) => {
    const index = incubatorList.findIndex((x: any) => x.id == id);
    setMouseOverFlag(incubatorList[index].id);
  };

  const handleRowChange = (id:any,isSelected:any,isBlocked:any,ev: any, status_id: any, incubator_preferences_data:any,incubator_id:any) => {
    if (loggedInRole == "incubator") {
      //Previous condition was isSelected == 0 and isBlocked == 0
      if (isSelected == 0 || isSelected == 1) {
    //console.log(id,isSelected,isBlocked,"click")

        if (isBlocked == 0 || isBlocked == 1) {
    //console.log(id,isSelected,isBlocked,"click1")

          let flag = false;
          if (activeIndex == "tranche") {
            flag = true;
          } else {
            flag = false;
          }
          history.replace({
            pathname: "/view_startup_details",
            state: {
              application_id: id,
              logged_in_role: "incubator",
              isEditable: ((ev < currentdatenew)&&((incubator_preferences_data ===2 || incubator_preferences_data ===3 || incubator_preferences_data ===4 || incubator_preferences_data ===5|| incubator_preferences_data ===6) ||(isSelected == 1 && incubator_preferences_data == 7 && status_id == 7))) ? false:true,
              showPreference: showPreference,
              isClick:incubator_preferences_data,
              isPref:incubator_preferences_data,
              evaluationDate:ev,
              from:"",

              select_flag:isSelected,
              
            },
          });
        } else {
          let flag = false;
          if (activeIndex == "tranche") {
            flag = true;
          } else {
            flag = false;
          }
          history.replace({
            pathname: "/view_startup_details",
            state: {
              application_id: id,
              logged_in_role: "incubator",
              isEditable: false,
              showPreference: showPreference,
              isClick:incubator_preferences_data
            },
          });
        }
      }
    } else if (loggedInRole == "secretariat") {
      history.replace({
        pathname: "/secretariat_startup_details",
        state: {
          application_id: id,
          logged_in_role: "secretariat",
          showPreference: showPreference,
          from:props.location.state.from,
          incubator_id:incubator_id
          
        },
      });
    } else if (loggedInRole == "dpiit") {
      history.replace({
        pathname: "/secretariat_startup_details",
        state: {
          application_id: id,
          logged_in_role: "dpiit",
          showPreference: showPreference,
          from:props.location.state.from,
        },
      });
    } else if (loggedInRole == "eac") {
      history.replace({
        pathname: "/eac_startup_details",
        state: {
          application_id: id,
          logged_in_role: "eac",
          showPreference: showPreference,
          from:props.location.state.from,
        },
      });
    }
  };

  // const mouseOverEvent = (id: any) => {
  //     const index = incubatorList.findIndex(x => x.application_id == id);
  //     setMouseOverFlag(incubatorList[index].application_id)

  // }

  // handeling multiselect checkbox in dropdown value
  const onMultiSelectChange = (selectedIds: Array<string>, name: string) => {
    if (name == "state") {
      setStateValue(selectedIds);
    } else if (name == "sector") {
      setSectorValue(selectedIds);
    }
  };

  const resetFilter = () => {
    setTableHeading("All Applications");
    setActiveIndex("2");
    getDataByStatus("2")
    setStateValue([]);
    setSectorValue([]);
    setOneStartup(false);
    setFilterDate("");
    setFundingType("");
    setShowFilterDot(false);
    setNoStartup(false);
    if(loggedInRole == "dpiit" || loggedInRole == "secretariat"){
      getRestrictedIncubatorCount(props.location.state.user_id);
    }else{
      getIncubatorCount();
    }    
  };

  //get application status
  const getApplicationStatus = () => {
    get(GET_STARTUP_APPLICATION_STATUS).then((response: any) => {
      if (!response || !response.data) return;
      const status = response.data.data.map((item: any) => ({
        label: item.label,
        value: item.id,
      }));
      const indexOfObject  = status.filter((item:any) => item.value == 8 || item.value == 7);
      const indexOfObject1  = status.filter((item:any) => item.value != 8 && item.value != 9);
      if( (startupStatus == 7 && (evalDate< currentdatenew)) || startupStatus == 8 && (evalDate< currentdatenew) ){
        // || startupStatus == 8 && (evalDate< currentdatenew)
        setApplicationStatus(indexOfObject);
      }else{
        console.log(indexOfObject1,"indexx")
        setApplicationStatus(indexOfObject1);
      }
      // setApplicationStatus(status);
    });
  };

  //get application status
  const getEngagementStatus = () => {
    get(GET_STARTUP_ENGAGEMENT_STATUS).then((response: any) => {
      if (!response || !response.data) return;
      const status = response.data.data.map((item: any) => ({
        label: item.label,
        value: item.id,
      }));
      setEngagementStatus(status);
    });
  };

  const [startupStatus,setStartupStatus] = useState<any>('');
  const [evalDate,setEvalDate] = useState<any>('')

  const quickEditData = (id: string,item:any) => {
    setStartupStatus(item.startup_status_id)
    setEvalDate(item.evaluation_to_be_completed_by)
    setquickEditPopupData({
      application_comments: "",
      application_id: "",
      application_status: "",
      engagement_status: "",
      corporate_id_no: "",
      incubator_name: "",
      no_of_tranches: "",
      date_of_evaluation: "",
      total_approved_amount: "",
    });
    getApplicationStatus();
    getEngagementStatus();
    get(`${STORE_STARTUP_APPLICATION}/${id}/quickEdit`).then(
      (response: any) => {
        if (!response || !response.data) return;
        setquickEditPopupData({
          application_comments: response.data.data.comment,
          application_id: response.data.data.id,
          application_status: response.data.data.startup_status_id,
          engagement_status:
            response.data.data.status_of_engagement != null
              ? response.data.data.status_of_engagement
              : "",
          corporate_id_no: response.data.data.recognition_number,
          incubator_name: response.data.data.name_of_entity,
          no_of_tranches:
            response.data.data.no_of_tranches != null
              ? response.data.data.no_of_tranches
              : "0",
          date_of_evaluation:
            response.data.data.date_of_evaluation != null
              ? response.data.data.date_of_evaluation
              : "",
          total_approved_amount:
            response.data.data.total_approved_amount != null
              ? response.data.data.total_approved_amount
              : "0",
        });
        if (response.data.data.startup_status_id == "7") {
          setSelectFlag(false);
        } else if (response.data.data.startup_status_id != "7") {
          setSelectFlag(true);
        }
        //   if (response.data.data.requested_tranchData.length != 0) {
        //     setShowEditTranche(true);
        //   }
        //   else if (response.data.data.requested_tranchData.length == 0) {
        //     setShowEditTranche(false);
        //   }
      }
    );
  };

  const quickEditCall = () => {
    //console.log(quickEditPopupData);
    setSelectFlag(true);
    var payload = {};
    payload = {
      comment: quickEditPopupData.application_comments,
      date_of_evaluation: quickEditPopupData.date_of_evaluation,
      startup_status_id: quickEditPopupData.application_status,
      no_of_tranches: quickEditPopupData.no_of_tranches,
      total_approved_amount: quickEditPopupData.total_approved_amount,
      status_of_engagement: quickEditPopupData.engagement_status,
    };

    setDisabled(true);
    post(
      `${STORE_STARTUP_APPLICATION}/${quickEditPopupData.application_id}/quickEdit`,
      payload
    ).then((response: any) => {
      //console.log(response);
      if (!response || !response.data) return;
      //console.log(response.data);

      getIncubatorCount();
      setTableHeading("All Applications");
      setActiveIndex("2");

      // setActiveIndex("");
      if (response.data.result == "success") {
        setDialogData({
          header: "Thank You!",
          text: "Application has been Updated Successfully !!!",
        });
        setShowIncubatorSuccessModal(true);
        setDisabled(false);
      } else {
        setFailDialogData({
          header: "Oops,Something went wrong",
          text: response.data.message,
        });
        setShowIncubatorFailureModal(true);
        setDisabled(false);
      }
      //console.log(response.data);
    });
    setquickEditPopupData({
      application_comments: "",
      application_id: "",
      application_status: "",
      engagement_status: "",
      corporate_id_no: "",
      incubator_name: "",
      no_of_tranches: "",
      date_of_evaluation: "",
      total_approved_amount: "",
    });
  };

  // apply filter button click function
  const applyFilter = () => {
    
    if (loggedInRole == "dpiit" || loggedInRole == "secretariat") {
      if (
        selectedStateValue.length != 0 ||
        selectedSectorValue.length != 0 ||
        filterDate != "" ||
        fundingType != ""
      ) {
        setShowFilterDot(true);
      } else {
        setShowFilterDot(false);
      }

      setTableHeading("All Applications");
      setActiveIndex("2");
      getDataByStatus("2");
      var payload = {};
      payload = {
        list_from: "incubator",
        incubator_id: incubatorUserId,
        // leagel_entity_id:
        //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
        state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
        sector_id: selectedSectorValue.length != 0 ? selectedSectorValue : null,
        submitted_date: filterDate,
        instrument_applying_for: fundingType,
        intial_call:'yes',
        status_id: [2],
        // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
        // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
      };
      post(GET_STARTUP_LISTING, payload).then((response: any) => {
        if (!response || !response.data) return;
        const counts = {
          incomplete: "0",
          onHold: "0",
          pendingReview: "0",
          rejected: "0",
          selected: "0",
          submitted: "0",
          reviewCount: response.data.reviewCount
            ? response.data.reviewCount
            : "0",
          trancheRequest: response.data.tranceRequestedCount,
          closed: "0",
          cancel:response.data.cancellationRequestedCount,
        cancelled: response.data.cancellationApprovedCount,
        };
        const status_id = {
          incomplete_id: "",
          onHold_id: "",
          pendingReview_id: "",
          rejected_id: "",
          selected_id: "",
          submitted_id: "",
          trancheRequest_id: "",
          closed_id: "",
          cancelled_id: "",
        };
        for (var i = 0; i < response.data.mainCount.length; i++) {
          if (response.data.mainCount[i].name == "incomplete") {
            counts.incomplete = response.data.mainCount[i].appln_count;
            status_id.incomplete_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "pending_review") {
            counts.pendingReview = response.data.mainCount[i].appln_count;
            status_id.pendingReview_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "submitted") {
            counts.submitted = response.data.mainCount[i].appln_count;
            status_id.submitted_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "on_hold") {
            counts.onHold = response.data.mainCount[i].appln_count;
            status_id.onHold_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "rejected") {
            counts.rejected = response.data.mainCount[i].appln_count;
            status_id.rejected_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "selected") {
            counts.selected = response.data.mainCount[i].appln_count;
            status_id.selected_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "closed") {
            counts.closed = response.data.mainCount[i].appln_count;
            status_id.closed_id = response.data.mainCount[i].id;
          }
          // else if (response.data.mainCount[i].name == 'cancelled') {
          //     counts.cancelled = response.data.mainCount[i].appln_count;
          //     status_id.cancelled_id = response.data.mainCount[i].id;
          // }
        }

        setIncubatorListingCounts(counts);
        setIncubatorListId(status_id);
        setincubatorListCountHead(response.data.applications.length);        
        console.log(incubatorListCountHead);
        if (response.data.applications.length != 0) {
          setincubatorList(response.data.applications);          
          setFilteredIncubatorList([]);   
          getDataByStatus("2");      
        } else {
          setincubatorList([]);
        }
        setincubatorListCountHead(response.data.applications.length);
      });
    } else {
      if (
        selectedStateValue.length != 0 ||
        selectedSectorValue.length != 0 ||
        filterDate != "" ||
        fundingType != ""
      ) {
        setShowFilterDot(true);
      } else {
        setShowFilterDot(false);
      }

      setTableHeading("All Applications");
      setActiveIndex("2");
      getDataByStatus("2");
      var payload = {};
      payload = {
        // leagel_entity_id:
        //     selectedEntityValue.length != 0 ? selectedEntityValue : null,
        state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
        sector_id: selectedSectorValue.length != 0 ? selectedSectorValue : null,
        submitted_date: filterDate,
        instrument_applying_for: fundingType,
        intial_call:'yes',
        status_id: [2],
        // startup_funded_incubators: oneStartupCheckbox ? 'yes' : '',
        // no_startup_funded_incubators: noStartupCheckbox ? 'yes' : '',
      };
      post(GET_STARTUP_LISTING, payload).then((response: any) => {
        console.log(response.data.applications,"apply")
        
        if (!response || !response.data) return;
        const counts = {
          incomplete: "0",
          onHold: "0",
          pendingReview: "0",
          rejected: "0",
          selected: "0",
          submitted: "0",
          reviewCount: response.data.reviewCount
            ? response.data.reviewCount
            : "0",
          trancheRequest: response.data.tranceRequestedCount,
          closed: "0",
          cancel:response.data.cancellationRequestedCount,
          cancelled: response.data.cancellationApprovedCount,
        };
        const status_id = {
          incomplete_id: "",
          onHold_id: "",
          pendingReview_id: "",
          rejected_id: "",
          selected_id: "",
          submitted_id: "",
          trancheRequest_id: "",
          closed_id: "",
          cancelled_id: "",
        };
        for (var i = 0; i < response.data.mainCount.length; i++) {
          if (response.data.mainCount[i].name == "incomplete") {
            counts.incomplete = response.data.mainCount[i].appln_count;
            status_id.incomplete_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "pending_review") {
            counts.pendingReview = response.data.mainCount[i].appln_count;
            status_id.pendingReview_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "submitted") {
            counts.submitted = response.data.mainCount[i].appln_count;
            status_id.submitted_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "on_hold") {
            counts.onHold = response.data.mainCount[i].appln_count;
            status_id.onHold_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "rejected") {
            counts.rejected = response.data.mainCount[i].appln_count;
            status_id.rejected_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "selected") {
            counts.selected = response.data.mainCount[i].appln_count;
            status_id.selected_id = response.data.mainCount[i].id;
          } else if (response.data.mainCount[i].name == "closed") {
            counts.closed = response.data.mainCount[i].appln_count;
            status_id.closed_id = response.data.mainCount[i].id;
          }
          // else if (response.data.mainCount[i].name == 'cancelled') {
          //     counts.cancelled = response.data.mainCount[i].appln_count;
          //     status_id.cancelled_id = response.data.mainCount[i].id;
          // }
        }
        setIncubatorListingCounts(counts);
        setIncubatorListId(status_id);
        setincubatorListCountHead(response.data.applications.length); 
        if (response.data.applications.length != 0) {
          setincubatorList(response.data.applications);
          setFilteredIncubatorList([]);
          getDataByStatus("2")  
        } else {
          setincubatorList([]);
        }
        setincubatorListCountHead(response.data.applications.length);
      });
      
    }
    
  };
  // allcheckbox check
  const handleAllCheck = (e: any /*index:number*/) => {
    var name = e.target.name;
    // console.log(e.target.name, "nameeeee")
    var isChecked = e.target.checked;
    if (isChecked) {
      setCheckedArray([]);
      console.log(incubatorList,"incubatorList")
      incubatorList.map((item:any) => {
       
        if (item.evaluation_to_be_completed_by > currentdatenew) {
          setCheckedArray((oldArray) => [...oldArray, item.id]);
        }else if((item.evaluation_to_be_completed_by < currentdatenew)&&(item.already_selected_flag == 0) ){
          
          if(item.incubator_preferences_data !==2 && item.incubator_preferences_data !==3 &&item.incubator_preferences_data !==4&& item.incubator_preferences_data !==5){
            setCheckedArray((oldArray) => [...oldArray, item.id]);
          }
        }
        
        
      });
      setIsChecked(true);
    
    } else if (isChecked == false) {
      setIsChecked(false);
      setCheckedArray([]);
    }
  };
  const handleListChange = (e: any) => {
    var value:any = Number(e.target.value);
    var isChecked = e.target.checked;
  
    if (isChecked) {
      setButtonDisable(false);
      if (!checkedArray.includes(value)) {
        setCheckedArray((oldArray: any) => [...oldArray, value]);
      }
    } else {
      if (checkedArray.includes(value)) {
        setCheckedArray(checkedArray.filter((item: any) => item !== value));
      }
    }
  };
  
  
  
  
  
  
  // const handleAllCheck = (e: any /*index:number*/) => {
  //   var name = e.target.name;
  //   // console.log(e.target.name, "nameeeee")
  //   var isChecked = e.target.checked;
  //   if (isChecked) {
  //     setCheckedArray([]);
  //     incubatorList.map(({ incubator_application_no }) =>
  //       setCheckedArray((oldArray) => [...oldArray, incubator_application_no])
  //     );
  //     setIsChecked(true);
  //   } else if (isChecked == false) {
  //     setIsChecked(false);
  //     setCheckedArray([]);
  //   }
  // };
  // setCheckedArrayCount(checkedArray.length);
 
  // const handleListChange = (e: any /*index:number*/) => {
  //   var value = e.target.value;
  //   var isChecked = e.target.checked;

  //   if (isChecked) {
  //     setButtonDisable(false);
  //     if (checkedArray.includes(value) == false) {
  //       setCheckedArray((oldArray) => [...oldArray, value]);
  //     }
  //   } else if (isChecked == false) {
  //     if (checkedArray.includes(value)) {
  //       setCheckedArray(checkedArray.filter((item) => item !== value));
  //     }
  //   }
  // };

  // on incubator dropdown change
  const handleOnChange = (e: any /*index:number*/) => {
    var value = e.target.value;
    setincubatorMeetingType(value);
  };

  // trrigers on date change
  const handleDateChange = (date: Date, field: string) => {
    setScheduleDate(formatDate(date));
    setSelectedDateControl(date);
    if (field == "submissionDate") {
      setFilterDate(formatDate(date));
    }
  };

  // function to format date
  function formatDate(date: Date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  // on change time;
  const onTimeChange = (e: any /*index:number*/) => {
    var value = e.target.value;
    var name = e.target.name;
    if (name == "fromTime") {
      setFromTime(value);
    } else if (name == "toTime") {
      setToTime(value);
    }
  };

  const scheduleMeetingFunction = () => {
    var time = new Date();
    var curTime = moment(time, "HH:mm").format("HH:mm");
    if (!compareTime(fromTime, toTime)) {
      setTimeValidation(true);
      setTimeValidationCurrentTime(false);
      return false;
    } else if (compareTime(fromTime, toTime)) {
      setTimeValidation(false);
      setTimeValidationCurrentTime(false);
    }

    const data = {
      meeting_date: scheduleDate != "" ? scheduleDate : formatDate(new Date()),
      meeting_from_time: fromTime != "" ? fromTime : "",
      meeting_to_time: toTime != "" ? toTime : "",
      meeting_type: incubatorMeetingType != "" ? incubatorMeetingType : "",
      link: meetingLink,
      startup_application_ids: checkedArray.length != 0 ? checkedArray : [],
      warning_ignore: 0,
    };
    if (meetingLink == "") {
      setLinkValidation(true);
      return false;
    }
    if (
      formatDate(new Date()) == data.meeting_date &&
      compareTime(fromTime, curTime)
    ) {
      setTimeValidationCurrentTime(true);
      setLinkValidation(false);
      setTimeValidation(false);
      return false;
    }
    if (checkedArray.length == 0) {
      setFailDialogData({
        header: "",
        text: "Please select atleast one Startup!!",
      });
      setShowIncubatorFailureModal(true);
      return;
    }
    setDisabled(true);
    setTimeValidation(false);
    setTimeValidationCurrentTime(false);
    post(STARTUP_SCHEDULE_MEETING, data).then((response: any) => {
      if (!response || !response.data) return;
      if (response.data.result == "success") {
        setDialogData({
          header: "Thank You!",
          text: "Your meeting has been scheduled !!!",
        });
        setShowIncubatorSuccessModal(true);

        setDisabled(false);
      } else if (response.data.result == "warning") {
        setConfirmationDialogData({
          header: "Meeting Already Exist",
          text: response.data.message,
        });
        setShowConfirmationBox(true);
        setDisabled(false);
      } else if (response.data.result == "error") {
        setFailDialogData({
          header: "Oops !!",
          text: response.data.message,
        });
        setShowIncubatorFailureModal(true);
        setDisabled(false);
      } else {
        setFailDialogData({
          header: "Oops !!",
          text: "Internal Server Error",
        });
        setShowIncubatorFailureModal(true);
        setDisabled(false);
      }
    });
  };

  const finalSchedule = () => {
    const data = {
      meeting_date: scheduleDate != "" ? scheduleDate : formatDate(new Date()),
      meeting_from_time: fromTime != "" ? fromTime : "",
      meeting_to_time: toTime != "" ? toTime : "",
      meeting_type: incubatorMeetingType != "" ? incubatorMeetingType : "",
      startup_application_ids: checkedArray.length != 0 ? checkedArray : [],
      link: meetingLink,
      warning_ignore: 1,
    };
    setDisabled(true);
    post(STARTUP_SCHEDULE_MEETING, data).then((response: any) => {
      if (!response || !response.data) return;
      setShowConfirmationBox(false);
      if (response.data.result == "success") {
        setDialogData({
          header: "Thank You!",
          text: "Your meeting has been scheduled !!!",
        });

        setShowIncubatorSuccessModal(true);
        setDisabled(false);
      } else {
        setFailDialogData({
          header: "Oops !!",
          text: response.data.message,
        });
        setShowIncubatorFailureModal(true);
        setDisabled(false);
      }
    });
  };

  const handlePopupDateChange = (date: Date, field: string) => {
    setquickEditPopupData((prevState) => ({
      ...prevState,
      date_of_evaluation: formatDate(date),
    }));
  };

  // popup change
  const handlePopupChange = (e: any /*index:number*/) => {
    var value = e.target.value
    var name = e.target.name;
    if (name == "status_id") {
      setquickEditPopupData((prevState) => ({
        ...prevState,
        application_status: value,
      }));
      setquickEditPopupData((prevState) => ({
        ...prevState,
        application_comments: "",
      }));
      if (value == "7") {
        setSelectFlag(false);
      } else if (value != "7") {
        setSelectFlag(true);
      }
    } else if (name == "popup_comments") {
      setquickEditPopupData((prevState) => ({
        ...prevState,
        application_comments: value,
      }));
    } else if (name == "engagement_status") {
      setquickEditPopupData((prevState) => ({
        ...prevState,
        engagement_status: value,
      }));
    } else if (name == "no_of_tranches") {
      setquickEditPopupData((prevState) => ({
        ...prevState,
        no_of_tranches: value,
      }));
    } else if (name == "total_approved_amount") {
      setquickEditPopupData((prevState) => ({
        ...prevState,
        total_approved_amount: value.toString().split(".").map((el:any,i:any)=>i?el.split("").slice(0,2).join(""):el).join("."),
      }));
    }
  };

  const dismissModal = () => {
    setShowIncubatorSuccessModal(false);
    setShowIncubatorFailureModal(false);
    // setShowEditFailureModal(false);
    // setShowEditSuccessModal(false);
    window.location.reload();
  };

  const downloadExcel = () => {
    var payload = {};
    if (loggedInRole == "secretariat" || loggedInRole == "dpiit") {
      if (activeIndex == "tranche") {
        payload = {
          applications_type: "startup",
          tranche_requested: "Yes",
          list_from: "incubator",
          incubator_id: incubatorUserId,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      } else if (activeIndex == "cancel") {
        payload = {
          applications_type: "startup",
          cancellation_requested: "Yes",
          list_from: "incubator",
          incubator_id: incubatorUserId,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      } else {
        payload = {
          applications_type: "startup",
          status_id: [...activeIndex],
          list_from: "incubator",
          incubator_id: incubatorUserId,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      }
      // //console.log(payload,"payload1")

      post(DOWNLOAD_EXCEL, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.result == "success") {
          downloadDocument(response.data.data, "startup_list");
        }else if(response.data.result == "fail"){
          setFailDialogData({
            header: "Oops !!",
            text: response.data.message,
          });
          setShowIncubatorFailureModal(true);
        }

      });
    } else {
      if (activeIndex == "tranche") {
        payload = {
          applications_type: "startup",
          tranche_requested: "Yes",
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      } else if (activeIndex == "cancel") {
        payload = {
          applications_type: "startup",
          cancellation_requested: "Yes",
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      } else {
        payload = {
          applications_type: "startup",
          status_id: activeIndex,
          state_id: selectedStateValue.length != 0 ? selectedStateValue : null,
          sector_id:
            selectedSectorValue.length != 0 ? selectedSectorValue : null,
          submitted_date: filterDate,
          instrument_applying_for: fundingType,
        };
      }
      // //console.log(payload,"payloads")
      post(DOWNLOAD_EXCEL, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.result == "success") {
          downloadDocument(response.data.data, "startup_list");
        }else if(response.data.result == "fail"){
          setFailDialogData({
            header: "Oops !!",
            text: response.data.message,
          });
          setShowIncubatorFailureModal(true);
        }
      });
    }
  };

  return (
    <>
      <div className="app-inside app-startup-listing">
        <div className="startup-listing-wrapper mt-4">
          <div className="container container-min pt-2">
            <div className="app-inside-content">
              <div className="row mb-3">
                <div className="col-md-6">
                  <p className="dashboard pt-2">Startups</p>
                </div>
                <div className="col-md-5 text-right ">
                  <div className="d-flex searchDiv">
                    {" "}
                    <img src={search} className="search" alt="search" />
                    <input
                      className="searchBar"
                      type="text"
                      placeholder=" Search.."
                      name="search"
                      onKeyUp={searchList}
                    />
                  </div>
                </div>
                <div className="col-md-1 filter-icon">
                  <img
                    src={filter}
                    className="img-fluid filter"
                    alt="SISFS Logo"
                    data-toggle="modal"
                    data-target="#filterModal"
                  />
                  {showFilterDot == true ? <mark></mark> : null}
                </div>
              </div>

              <div className="d-flex cardDiv" style={{marginLeft:'-75px'}}>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.submitted_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.submitted_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.submitted_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.submitted}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.submitted_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Submitted
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.pendingReview_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.pendingReview_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.pendingReview_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.pendingReview}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.pendingReview_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications to
                      <br />
                      &nbsp;be Reviewed
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.incomplete_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.incomplete_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.incomplete_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.incomplete}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.incomplete_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Incomplete
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.onHold_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.onHold_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.onHold_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.onHold}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.onHold_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications <br />
                      on Hold
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.selected_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.selected_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.selected_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.selected}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.selected_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Selected
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.rejected_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.rejected_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.rejected_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.rejected}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.rejected_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Rejected
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() =>
                    getDataByStatus(`${incubatorListId.closed_id}`)
                  }
                >
                  <div
                    className={
                      activeIndex == incubatorListId.closed_id
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == incubatorListId.closed_id
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.closed}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == incubatorListId.closed_id
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Closed
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() => getDataByStatus("cancelled")}
                >
                  <div
                    className={
                      activeIndex == "cancelled"
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == "cancelled"
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.cancelled}
                       {/* {(Cancellation_Approved_Count == 0 || Cancellation_Approved_Count == "")?0:Cancellation_Approved_Count} */}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == "cancelled"
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Applications Cancelled
                    </span>
                  </div>
                </div>
                <span style={{ borderLeft: "2px solid rgb(108 117 125 / 12%)",marginLeft:'10px',marginRight:'10px' }}></span>
                <div
                  className="incubator-card"
                  onClick={() => getDataByStatus("tranche")}
                >
                  <div
                    className={
                      activeIndex == "tranche"
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == "tranche"
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.trancheRequest}
                      {/* {console.log(Tranche_Requested_Count,"Tranche_Requested_Count")} */}
                      {/* {(Tranche_Requested_Count == 0 || Tranche_Requested_Count == "")?0:Tranche_Requested_Count} */}
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == "tranche"
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Tranche Requested
                    </span>
                  </div>
                </div>
                <div
                  className="incubator-card"
                  onClick={() => getDataByStatus("cancel")}
                >
                  <div
                    className={
                      activeIndex == "cancel"
                        ? "rectangle-card-selected"
                        : "rectangle-card"
                    }
                  >
                    <span
                      className={
                        activeIndex == "cancel"
                          ? "smallIncubatorNumeric"
                          : "incubator-numeric-black"
                      }
                    >
                      {incubatorListingCounts.cancel}
                      {/* {(Cancellation_Requested_Count == 0 || Cancellation_Requested_Count == "")?0:Cancellation_Requested_Count} */}
                     
                    </span>
                    <br />
                    <span
                      className={
                        activeIndex == "cancel"
                          ? "incubator-text-selected-small"
                          : "card-text-incubator"
                      }
                    >
                      Cancellation Requested
                    </span>
                  </div>
                </div>

                
              </div>
              <div className="row incubator-heading-div">
                <div className="col-md-4 pt-2">
                  <span className="table-head">{tableHeading}</span>
                  <br />
                  <p className="count-text-incubator">
                    {/* {console.log(incubatorListCountHead,"apply")} */}
                    ({incubatorListCountHead} Results)
                  </p>
                </div>
                <div className="col-md-8 text-right">
                  {loggedInRole == "incubator" && (
                    <button
                      className={
                        buttonDisable == true
                          ? "tertiary  btn-yellow-primary btn-yellow-disabled"
                          : "tertiary  btn-yellow-primary"
                      }
                      disabled={buttonDisable}
                      data-toggle="modal"
                      data-target="#scheduleMeeting"
                    >
                      SCHEDULE A MEETING
                    </button>
                  )}
                  <button
                    className="tertiary  btn-yellow-primary ml-3 mr-3"
                    onClick={() => downloadExcel()}
                  >
                    DOWNLOAD EXCEL
                  </button>
                  {/* <button className="btn btn-sisfs btn-transparent-primary">
              UPLOAD XL
            </button> */}
                </div>
              </div>
              <div className="table-scroll mb-5">
                <table className="reviewTable" id="customTable">
                  <thead>
                    <tr>
                      {checkBoxHide == false
                        ? loggedInRole == "incubator" && (
                            <th className="text-center table-heading">
                              {/* <input className="form-check-input" type="checkbox" onChange={handleAllCheck} /> */}

                              <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                id="customcheckbox1"
                                name="customcheckbox"
                                className="custom-control-input"
                                onChange={handleAllCheck}
                              />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customcheckbox1"
                                ></label>
                              </div>
                            </th>
                          )
                        : null}
                        <th className="text-left table-heading">
                       DIPP Number
                      </th>
                      <th className="text-left table-heading" style={{width:'220px'}}>Startup Name</th>

                      {/* {columnHideFlag == true ? (
                                                <th className="text-left table-heading custom-td">
                                                    Amount Disbursed to Startups (&#8377;)
                                                </th>
                                            ) : null} */}
                      {columnHideFlag != true ? (
                        <th className="text-center table-heading">Industry</th>
                      ) : null}
                      {columnHideFlag != true ? (
                        <th className="text-center table-heading">Sector</th>
                      ) : null}
                      {columnHideFlag != true ? (
                        <th className="text-left table-heading">
                          Evaluation To be Completed By
                        </th>
                      ) : null}
                      {activeIndex == "cancel" && (
                        <th className="text-left table-heading">Status</th>
                      )}
                        {activeIndex == "cancelled" && (
                        <th className="text-left table-heading">Status</th>
                      )}
                      <th className="text-left table-heading">
                        Quantum of Funds Required (&#8377;)
                      </th>

                      {columnHideFlag == true ? (
                        <th className="text-left table-heading">
                          Funds Approved (&#8377;)
                        </th>
                      ) : null}
                      {columnHideFlag == true ? (
                        <th className="text-left table-heading">
                          Funds Disbursed{" "}
                        </th>
                      ) : null}
                      {columnHideFlag == true
                        ? loggedInRole == "incubator" && (
                            <th className="text-center custom-td table-heading">
                              Meeting Details
                            </th>
                          )
                        : null}
                    </tr>
                  </thead>
                  <tbody>
                    {/* {console.log(incubatorList,"incubatorListincubatorList")} */}
                    {incubatorList.length == 0 ? (
                      <tr>
                        <td className="text-center table-heading" colSpan={7}>
                          No data
                        </td>
                      </tr>
                    ) : filteredIncubatorList.length == 0 ? (
                      incubatorList.map((item: any,index) => (
                        <tr key={index}
                          // className={ 
                          //   item.already_selected_flag == 1 ||
                          //   (item.incubator_preferences_data==6 && item.startup_status_id>2)  || item.startup_status_id==6
                          //     ? "custom-disabled"
                          //     : ""
                          // }
                          
                          // className={ 
                             
                            // ((item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id ===2 || item.startup_status_id ===3 || item.startup_status_id ===5)) ? "custom-disabled": ""
                          // }
                          
                        >
                          {checkBoxHide == false
                            ? loggedInRole == "incubator" && (
                                <td>
                                  {/* <input
                          type="checkbox"
                          disabled={isChecked}
                          onChange={handleListChange}
                          value={application_id}
                        /> */}
                                  {/* <input className="form-check-input" type="checkbox"  value={application_id}
                            id={application_id}
                            name={application_id}    disabled={isChecked}
                            onChange={handleListChange}/> */}
                                  <div className="custom-control custom-checkbox">
                                    {/* <input
                                      type="checkbox"
                                      value={item.id}
                                      id={item.name_of_entity + "_" + item.id}
                                      name={item.name_of_entity + "_" + item.id}
                                      className="custom-control-input"
                                      disabled={isChecked}
                                      onChange={handleListChange}
                                    /> */}
                                    {/* {console.log(checkedArray,item.id,"checkedArray")} */}
                                     <input
                                      type="checkbox"
                                      value={item.id}
                                      id={item.name_of_entity + "_" + item.id}
                                      name={item.name_of_entity + "_" + item.id}
                                      className="custom-control-input"
                                    disabled={(item.evaluation_to_be_completed_by < currentdatenew) && (item.incubator_preferences_data === 2 || item.incubator_preferences_data === 3 || item.incubator_preferences_data === 4 || item.incubator_preferences_data === 5) || (item.already_selected_flag === 1 && item.incubator_preferences_data===7 && item.startup_status_id===7)}
                                      checked={checkedArray.includes(item.id)}
                                      onChange={handleListChange}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={
                                        item.name_of_entity + "_" + item.id
                                      }
                                    ></label>
                                  </div>
                                </td>
                              )
                            : null}
                            {/* {columnHideFlag !== true ? ( */}
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id                                 
                                )
                              }
                              className="text-left custom-td-small custom-tdd-small customcenter"
                            >
                               
                               <span className="tableDataHead">
                              {item.recognition_number}
                            </span>
                            {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.incubator_preferences_data ===2 || item.incubator_preferences_data ===3 ||item.incubator_preferences_data ===4|| item.incubator_preferences_data ===5) && (
                              <span className="rejected-flag">
                                System Rejected{/* {item.evaluation_to_be_completed_by}{' '}{item.startup_status_id} */}
                              </span>
                            )}
                             {/* {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id === 6) && (
                              <span className="rejected-flag">
                                Rejected
                              </span>
                            )} */}
                            {item.already_selected_flag == 1  && item.incubator_preferences_data==7 && item.startup_status_id==7 && (item.evaluation_to_be_completed_by < currentdatenew)&& (
                              <span className="selected-flag">
                                Allotted to Another Incubator
                                {/* {item.already_selected_flag}{item.incubator_preferences_data}{item.startup_status_id} */}
                              </span>
                            )}
                            </td>
                         
                         
                          <td
                            className="text-left custom-td"
                            onClick={() =>
                              handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                              )
                            }
                          >
                            <span className="tableDataHead">
                              {item.name_of_entity}
                            </span>
                            <br />
                            <span className="tableDataApplication">
                              {"No: " + item.id}
                            </span>
                            
{/* {item.evaluation_to_be_completed_by} {currentdatenew} */}
                            {/* {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id ===2 || item.startup_status_id ===3 ||item.startup_status_id ===4|| item.startup_status_id ===5) && (
                              <span className="rejected-flag">
                                System Rejected
                                {item.evaluation_to_be_completed_by}{' '}{item.startup_status_id}
                              </span>
                            )} */}
                             {/* {(item.evaluation_to_be_completed_by < currentdate)&&(item.startup_status_id !== 6 && item.startup_status_id !== 7) ? (
                              <span className="rejected-flag">
                                System Rejected 
                                
                              </span>
                            ):''} */}
                                {/* {item.evaluation_to_be_completed_by}{'sr'}{item.startup_status_id} */}

                          </td>
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small customcenter"
                            >
                              {item.industries.map(
                                (industry: any) => industry.industry_name + " "
                              )}
                            </td>
                          ) : null}
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small customcenter"
                            >
                              {item.sectors.map(
                                (sector: any) => sector.sector_name
                              )}
                            </td>
                          ) : null}
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small"
                            >
                              {item.evaluation_to_be_completed_by}
                            </td>
                          ) : null}
                          {/* {console.log(item,"item@@@@@")} */}
                          {activeIndex == "cancel" && (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small custom-td-right"
                            >
                              
                              {item.cancellation_status}
                            </td>
                          )}
                          {activeIndex == "cancelled" && (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small custom-td-right"
                            >
                              
                              {item.cancellation_status}
                            </td>
                          )}
{/* <td></td> */}
                          <td
                            onClick={() =>
                              handleRowChange(
                                item.id,
                                item.already_selected_flag,
                                item.is_blocked,
                                item.evaluation_to_be_completed_by,
                                item.startup_status_id,
                                item.incubator_preferences_data,
                                item.incubator_id
                              )
                            }
                            className="text-center custom-td-small custom-td-right"
                          >
                            {item.quantum_funds_required
                              ? changeNumberFormat(
                                  Number(item.quantum_funds_required),
                                  1,
                                  0
                                )
                              : 0}
                          </td>

                          {columnHideFlag == true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-left custom-td"
                            >
                              {item.total_applroved_amount
                                ? changeNumberFormat(
                                    Number(item.total_applroved_amount),
                                    1,
                                    0
                                  )
                                : 0}
                            </td>
                          ) : null}
                          {columnHideFlag == true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-left custom-td"
                            >
                              {item.total_disbursed_amount
                                ? changeNumberFormat(
                                    Number(item.total_disbursed_amount),
                                    1,
                                    0
                                  )
                                : 0}
                            </td>
                          ) : null}
                          {columnHideFlag == true
                            ? loggedInRole == "incubator" &&
                              (item.already_selected_flag == 0 ? (
                                <td
                                  data-toggle="modal"
                                  data-target="#quickEdit"
                                  className="text-center custom-td"
                                  onClick={() => quickEditData(item.id,item)}
                                  onMouseOver={() => mouseOverEvent(item.id)}
                                  onMouseOut={() => setMouseOverFlag("")}
                                >
                                  {/* (item.evaluation_to_be_completed_by<currentdate)&&(item.startup_status_id == '2'||item.startup_status_id == '3'||item.startup_status_id == '4'||item.startup_status_id == '5') */}
                                  {mouseOverFlag == item.id ? (
                                    <img
                                      src={edit}
                                      className="search"
                                      alt="search"
                                      data-toggle="modal"
                                      data-target="#quickEdit"
                                    />
                                  ) : (item.meetingData.meeting_date == "" &&
                                      typeof item.meetingData.meeting_time ==
                                        "undefined") ||
                                    item.meetingData.status == "NA" ? (
                                    // <>
                                    //   <div className="badge-red">
                                    //     Today:{meeting_time}
                                    //   </div>
                                    //   <span className="tableDataApplication">
                                    //     {meeting_date}
                                    //   </span>
                                    // </>
                                    <div className="badge-grey">
                                      {item.meetingData.status}
                                    </div>
                                  ) : item.meetingData.status == "Today" ? (
                                    <>
                                      <div className="badge-red">
                                        Today:{" "}
                                        {item.meetingData.meeting_time != null
                                          ? formatTime(
                                              item.meetingData.meeting_time
                                            )
                                          : ""}
                                      </div>
                                      <span className="tableDataApplication">
                                        {FormatDate(
                                          item.meetingData.meeting_date
                                        )}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div className="badge-grey">
                                        {item.meetingData.status}
                                      </div>
                                      <span className="tableDataApplication">
                                        {FormatDate(
                                          item.meetingData.meeting_date
                                        )}
                                      </span>
                                    </>
                                  )}
                                </td>
                              ) : (
                                <td className="text-center custom-td">
                                  <img
                                    src={edit}
                                    className="search"
                                    alt="search"
                                  />
                                </td>
                              ))
                            : null}

                          {/* <td
                                                                onMouseOver={() => mouseOverEvent(application_id)}
                                                                onMouseOut={() => setMouseOverFlag("")}
                                                                onClick={() => quickEditData(incubator_name, application_date, status_id, application_id)} data-toggle="modal" data-target="#quickEdit"
                                                                className="text-center edit-column"
                                                            >
                                                                {mouseOverFlag == application_id ? <img
                                                                    src={edit}
                                                                    className="search"
                                                                    alt="search"
                                                                /> :
                                                                    (meeting_date == "" && meeting_time == "") || meeting_status == "NA" ?
                                                                        // <>
                                                                        //   <div className="badge-red">
                                                                        //     Today:{meeting_time}
                                                                        //   </div>
                                                                        //   <span className="tableDataApplication">
                                                                        //     {meeting_date}
                                                                        //   </span>
                                                                        // </>
                                                                        <div className="badge-grey">{meeting_status}</div>
                                                                        :
                                                                        meeting_status == "Today" ?
                                                                            <>
                                                                                <div className="badge-red">
                                                                                    Today: {meeting_time != null ? formatTime(meeting_time) : ""}
                                                                                </div>
                                                                                <span className="tableDataApplication">
                                                                                    {FormatDate(meeting_date)}
                                                                                </span>
                                                                            </>
                                                                            : <>
                                                                                <div className="badge-grey">{meeting_status}</div>
                                                                                <span className="tableDataApplication">
                                                                                    {FormatDate(meeting_date)}
                                                                                </span>
                                                                            </>
                                                                }
                                                            </td> */}
                        </tr>
                      ))
                    ) : (
                      filteredIncubatorList.map((item: any,index) => (
                      
                        <tr key={index}
                        
                        // className={
                          // ((item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id ===2 || item.startup_status_id ===3 || item.startup_status_id ===5)) ? "custom-disabled": ""
                          // item.already_selected_flag == 1 ||
                          // (item.incubator_preferences_data == 6 &&
                          //   item.startup_status_id > 2) ||
                          // item.startup_status_id == 6
                          //   ? 'custom-disabled'
                          //   : ''
                          // }
                          // className={
                          //   item.already_selected_flag == 0 ||
                          //   item.startup_status_id != 6
                          //     ? "custom-disabled"
                              // : ""
                          // }
                          // className={
                          //   ((item.evaluation_to_be_completed_by < currentdate)&&(item.startup_status_id !== 6 && item.startup_status_id !== 7))
                          //     ? "custom-disabled"
                          //     : ""
                          // }
                          
                          // className={
                          //   // item.already_selected_flag == 1  && (item.incubator_preferences_data==7 && item.startup_status_id==7)

                          //   item.already_selected_flag == 1 ||
                          //   (item.incubator_preferences_data == 6 &&
                          //     item.startup_status_id > 2) ||
                          //   item.startup_status_id == 6
                          //     ? 'custom-disabled'
                          //     : ''
                          //   }
                        >
                          {checkBoxHide == false
                            ? loggedInRole == "incubator" && (
                                <td>
                                  {/* <input
                          type="checkbox"
                          disabled={isChecked}
                          onChange={handleListChange}
                          value={application_id}
                        /> */}
                                  {/* <input className="form-check-input" type="checkbox"  value={application_id}
                            id={application_id}
                            name={application_id}    disabled={isChecked}
                            onChange={handleListChange}/> */}
                                  <div className="custom-control custom-checkbox">
                                    {/* <input
                                      type="checkbox"
                                      value={item.id}
                                      id={item.name_of_entity + "_" + item.id}
                                      name={item.name_of_entity + "_" + item.id}
                                      className="custom-control-input"
                                      disabled={isChecked}
                                      // onChange={handleListChange}
                                    /> */}
{/* {console.log(item.evaluation_to_be_completed_by < currentdatenew,"current")}
{console.log(item.already_selected_flag === 1 ,"current")}
{console.log(item.already_selected_flag === 1 ,"current")} */}


                                     <input
                                      type="checkbox"
                                      value={item.id}
                                      id={item.name_of_entity + "_" + item.id}
                                      name={item.name_of_entity + "_" + item.id}
                                      className="custom-control-input"                                      
                                      disabled={(item.evaluation_to_be_completed_by < currentdatenew) && (item.incubator_preferences_data === 2 || item.incubator_preferences_data === 3 || item.incubator_preferences_data === 4 || item.incubator_preferences_data === 5) || (item.already_selected_flag === 1 && item.incubator_preferences_data===7 && item.startup_status_id===7)}


                                      checked={checkedArray.includes(item.id)}
                                      onChange={handleListChange}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor={
                                        item.name_of_entity + "_" + item.id
                                      }
                                    ></label>
                                  </div>
                                </td>
                              )
                            : null}
                            {/* {columnHideFlag != true ? ( */}
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-left custom-td-small custom-tdd-small customcenter"
                            >
                               <span className="tableDataHead">
                              {item.recognition_number}
                            </span>
                            {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.incubator_preferences_data === 2 || item.incubator_preferences_data === 3 || item.incubator_preferences_data === 4 || item.incubator_preferences_data === 5) && (
                              <span className="rejected-flag">
                                System Rejected{/* {item.evaluation_to_be_completed_by}{' '}{item.startup_status_id} */}
                              </span>
                            )}
                             {/* {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id === 6) && (
                              <span className="rejected-flag">
                                Rejected
                              </span>
                            )} */}
                            {item.already_selected_flag == 1 && item.incubator_preferences_data==7 && item.startup_status_id==7 && (
                              <span className="selected-flag">
                                Allotted to Another Incubator
                                {/* {item.already_selected_flag}{item.incubator_preferences_data==7}{item.startup_status_id==7} */}
                              </span>
                            )}
                            </td>
                          {/* ) : null} */}
                          <td
                            className="text-left custom-td"
                            onClick={() =>
                              handleRowChange(
                                item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                              )
                            }
                          >
                            
                            <span className="tableDataHead">
                              {item.name_of_entity}
                            </span>
                            
                            <br />
                            <span className="tableDataApplication">
                              {"No: " + item.id}
                            </span>
                            
                             {/* {(item.evaluation_to_be_completed_by < currentdatenew)&&(item.startup_status_id === 2 || item.startup_status_id === 3 || item.startup_status_id === 4 || item.startup_status_id === 5) && (
                              <span className="rejected-flag">
                                System Rejected
                                {item.evaluation_to_be_completed_by}{' '}{item.startup_status_id}
                              </span>
                            )} */}
                             {/* {item.startup_status_id>2 && item.incubator_preferences_data<6 && (
                              <span className="rejected-flag">
                                System Rejected
                              </span>
                            )} */}

                            {/* {item.startup_status_id>2 && item.incubator_preferences_data<6 && (
                              <span className="rejected-flag">
                                System Rejected
                              </span> */}
                            
                             {/* {(item.evaluation_to_be_completed_by < currentdate)&&(item.startup_status_id !== 6 && item.startup_status_id !== 7) ? (
                              <span className="rejected-flag">
                                System Rejected 
                                
                              </span> */}
                            {/* ):''} */}
                          </td>
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small customcenter"
                            >
                              {item.industries.map(
                                (industry: any) => industry.industry_name
                              )}
                            </td>
                          ) : null}
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small customcenter"
                            >
                              {item.sectors.map(
                                (industry: any) => industry.sector_name
                              )}
                            </td>
                          ) : null}
                          {columnHideFlag != true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small"
                            >
                              {item.evaluation_to_be_completed_by}
                            </td>
                          ) : null}
                          {activeIndex == "cancel" && (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small custom-td-right"
                            >
                              {item.cancellation_status}
                            </td>
                          )}
{activeIndex == "cancelled" && (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-center custom-td-small custom-td-right"
                            >
                              {item.cancellation_status}
                            </td>
                          )}
                          <td
                            onClick={() =>
                              handleRowChange(
                                item.id,
                                item.already_selected_flag,
                                item.is_blocked,
                                item.evaluation_to_be_completed_by,
                                item.startup_status_id,
                                item.incubator_preferences_data,
                                item.incubator_id
                              )
                            }
                            className="text-center custom-td-small custom-td-right"
                          >
                            {item.quantum_funds_required
                              ? changeNumberFormat(
                                  Number(item.quantum_funds_required),
                                  1,
                                  0
                                )
                              : 0}
                          </td>

                          {columnHideFlag == true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-left custom-td"
                            >
                              {item.total_applroved_amount
                                ? changeNumberFormat(
                                    Number(item.total_applroved_amount),
                                    1,
                                    0
                                  )
                                : 0}
                            </td>
                          ) : null}
                          {columnHideFlag == true ? (
                            <td
                              onClick={() =>
                                handleRowChange(
                                  item.id,
                                  item.already_selected_flag,
                                  item.is_blocked,
                                  item.evaluation_to_be_completed_by,
                                  item.startup_status_id,
                                  item.incubator_preferences_data,
                                  item.incubator_id
                                )
                              }
                              className="text-left custom-td"
                            >
                              {item.total_disbursed_amount
                                ? changeNumberFormat(
                                    Number(item.total_disbursed_amount),
                                    1,
                                    0
                                  )
                                : 0}
                            </td>
                          ) : null}
                          {columnHideFlag == true
                            ? loggedInRole == "incubator" &&
                              (item.already_selected_flag == 0 ? (
                                <td
                                  data-toggle="modal"
                                  data-target="#quickEdit"
                                  className="text-center custom-td"
                                  onClick={() => quickEditData(item.id,item)}
                                  onMouseOver={() => mouseOverEvent(item.id)}
                                  onMouseOut={() => setMouseOverFlag("")}
                                >
                                  {mouseOverFlag == item.id ? (
                                    <img
                                      src={edit}
                                      className="search"
                                      alt="search"
                                      data-toggle="modal"
                                      data-target="#quickEdit"
                                    />
                                  ) : (item.meetingData.meeting_date == "" &&
                                      typeof item.meetingData.meeting_time ==
                                        "undefined") ||
                                    item.meetingData.status == "NA" ? (
                                    // <>
                                    //   <div className="badge-red">
                                    //     Today:{meeting_time}
                                    //   </div>
                                    //   <span className="tableDataApplication">
                                    //     {meeting_date}
                                    //   </span>
                                    // </>
                                    <div className="badge-grey">
                                      {item.meetingData.status}
                                    </div>
                                  ) : item.meetingData.status == "Today" ? (
                                    <>
                                      <div className="badge-red">
                                        Today:{" "}
                                        {item.meetingData.meeting_time != null
                                          ? formatTime(
                                              item.meetingData.meeting_time
                                            )
                                          : ""}
                                      </div>
                                      <span className="tableDataApplication">
                                        {FormatDate(
                                          item.meetingData.meeting_date
                                        )}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div className="badge-grey">
                                        {item.meetingData.status}
                                      </div>
                                      <span className="tableDataApplication">
                                        {FormatDate(
                                          item.meetingData.meeting_date
                                        )}
                                      </span>
                                    </>
                                  )}
                                </td>
                              ) : (
                                <td className="text-center custom-td">
                                  <img
                                    src={edit}
                                    className="search"
                                    alt="search"
                                  />
                                </td>
                              ))
                            : null}

                          {/* <td
                                                                onMouseOver={() => mouseOverEvent(application_id)}
                                                                onMouseOut={() => setMouseOverFlag("")}
                                                                onClick={() => quickEditData(incubator_name, application_date, status_id, application_id)} data-toggle="modal" data-target="#quickEdit"
                                                                className="text-center edit-column"
                                                            >
                                                                {mouseOverFlag == application_id ? <img
                                                                    src={edit}
                                                                    className="search"
                                                                    alt="search"
                                                                /> :
                                                                    (meeting_date == "" && meeting_time == "") || meeting_status == "NA" ?
                                                                        // <>
                                                                        //   <div className="badge-red">
                                                                        //     Today:{meeting_time}
                                                                        //   </div>
                                                                        //   <span className="tableDataApplication">
                                                                        //     {meeting_date}
                                                                        //   </span>
                                                                        // </>
                                                                        <div className="badge-grey">{meeting_status}</div>
                                                                        :
                                                                        meeting_status == "Today" ?
                                                                            <>
                                                                                <div className="badge-red">
                                                                                    Today: {meeting_time != null ? formatTime(meeting_time) : ""}
                                                                                </div>
                                                                                <span className="tableDataApplication">
                                                                                    {FormatDate(meeting_date)}
                                                                                </span>
                                                                            </>
                                                                            : <>
                                                                                <div className="badge-grey">{meeting_status}</div>
                                                                                <span className="tableDataApplication">
                                                                                    {FormatDate(meeting_date)}
                                                                                </span>
                                                                            </>
                                                                }
                                                            </td> */}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {/* quick edit popup */}
              <div
                className="modal fade"
                id="quickEdit"
                role="dialog"
                aria-labelledby="exampleModalLabel1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-slideout modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header modal-header-bottom pr-5">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setSelectFlag(true)}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body pl-5 pr-5 pt-5">
                      <div className="popup-head mb-5 ml-2">
                        <div className="main-heading">
                          {quickEditPopupData.incubator_name}
                        </div>
                        <div className="count-text">
                          {"No: " + quickEditPopupData.application_id}
                        </div>
                      </div>

                      <label className="col-sm-8 col-form-head">
                        Total Grant Approved (
                        {quickEditPopupData.no_of_tranches} Tranches)
                      </label>
                      {showEditTranche ? (
                        <span
                          className="col-sm-4 text-left view-all"
                          data-dismiss="modal"
                          onClick={() =>
                            handleRowChange(
                              quickEditPopupData.application_id,
                              0,
                              0,                             
                              0,
                              0,
                              "",
                              0
                              
                            )
                          }
                        >
                          Edit Tranche
                        </span>
                      ) : null}
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <input
                            type="number"
                            id="total_approved_amount"
                            name="total_approved_amount"
                            className="form-control input-height"
                            value={quickEditPopupData.total_approved_amount}
                            onChange={handlePopupChange}
                            disabled={selectFlag}
                          />
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all">View</span>
                </div> */}
                      </div>

                      {/* <label className="col-sm-8 col-form-head">No. of Tranches</label>
                                            <div className="row pl-3">
                                                <div className="col-md-11 mb-4">
                                                    <input
                                                        type="number"
                                                        aria-label="Select State"
                                                        id="no_of_tranches"
                                                        name="no_of_tranches"
                                                        className="form-control input-height"
                                                        value={quickEditPopupData.no_of_tranches}
                                                        onChange={handlePopupChange}
                                                        disabled={selectFlag}
                                                    />
                                                </div>
                                               
                                            </div> */}

                      <label className="col-sm-8 col-form-head">
                        Application Status
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <div className="select-custom">
                            <select
                              className="form-control input-height"
                              aria-label="Select State"
                              id="status_id"
                              name="status_id"
                              value={quickEditPopupData.application_status}
                              onChange={handlePopupChange}
                            >
                              {applicationStatus.map(({ label, value }) =>
                                label !== "Draft" ? (
                                  <option key={label} value={value}>
                                    {label}
                                  </option>
                                ) : null
                              )}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all" onClick={() => setSelectFlag(false)}>Edit</span>
                </div> */}
                      </div>
                      <label className="col-sm-8 col-form-head">
                        Status of Engagement
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <div className="select-custom">
                            <select
                              className="form-control input-height"
                              aria-label="Select State"
                              id="status_id"
                              name="engagement_status"
                              value={quickEditPopupData.engagement_status}
                              onChange={handlePopupChange}
                              // disabled={selectFlag}
                            >
                              <option key="" value="">
                                Select
                              </option>
                              {engagementStatus.map(({ label, value }) => (
                                <option key={label} value={value}>
                                  {label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all" onClick={() => setSelectFlag(false)}>Edit</span>
                </div> */}
                      </div>
                      <div className="row pl-3 mb-4">
                        <div className="col-md-6">
                          <label className="col-form-head">
                            Date Of Evaluation
                          </label>
                          <fieldset disabled={selectFlag}>
                            <Calendar
                              id="registrationDate"
                              name="registrationDate"
                              className="form-control input-height"
                              format="dd/MM/yyyy"
                              selectedDate={
                                quickEditPopupData.date_of_evaluation
                              }
                              onDateChange={(date: Date, field: string) =>
                                handlePopupDateChange(date, field)
                              }
                              minDate={new Date()}
                            />
                          </fieldset>
                        </div>
                        <div className="col-md-5">
                          <label className="col-form-head">
                            No. of Tranches
                          </label>
                          <input
                            type="number"
                            aria-label="Select State"
                            id="no_of_tranches"
                            name="no_of_tranches"
                            className="form-control input-height"
                            value={quickEditPopupData.no_of_tranches}
                            onChange={handlePopupChange}
                            disabled={selectFlag}
                          />
                        </div>
                      </div>
                      {/* <label className="col-sm-8 col-form-head">Date Of Evaluation</label>
                                            <div className="row pl-3">

                                                <div className="col-md-11 mb-4">
                                                    <fieldset disabled={selectFlag}>
                                                        <Calendar
                                                            id="registrationDate"
                                                            name="registrationDate"
                                                            className="form-control input-height"
                                                            format="dd/MM/yyyy"
                                                            selectedDate={quickEditPopupData.date_of_evaluation}
                                                            onDateChange={(date: Date, field: string) =>
                                                                handlePopupDateChange(date, field)
                                                            }
                                                            minDate={new Date()}
                                                        />
                                                    </fieldset>
                                                </div>
                                            </div> */}
                      <label className="col-sm-8 col-form-head">
                        Comments, if any
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <textarea
                            value={quickEditPopupData.application_comments}
                            className="form-control textarea-height"
                            name="popup_comments"
                            onChange={handlePopupChange}
                          />
                        </div>
                      </div>
                      <div className="row pl-3">
                        <div className="col-md-6">
                          <button
                            className="btn btn-sisfs btn-transparent-primary full-width"
                            data-dismiss="modal"
                          >
                            CANCEL
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            className={
                              isDisabled
                                ? "tertiary  btn-yellow-primary full-width custom-disabled"
                                : "tertiary  btn-yellow-primary full-width"
                            }
                            disabled={isDisabled}
                            onClick={quickEditCall}
                          >
                            UPDATE
                          </button>
                        </div>
                      </div>

                      {/* <div className="row pl-5">
                <button
                  className="btn btn-sisfs btn-transparent-primary"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
                <button
                  className="tertiary  btn-yellow-primary ml-3"
                  onClick={scheduleMeetingFunction}
                >
                  SCHEDULE
                </button>
              </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* modal for filter */}
              <div
                className="modal fade"
                id="filterModal"
                role="dialog"
                aria-labelledby="exampleModalLabel1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-slideout modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header modal-header-bottom">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body pl-5 pr-5 pt-1">
                      <div className="popup-head mb-5 ml-3">
                        <div className="main-heading">Filters</div>
                      </div>

                      <label className="col-sm-4 col-form-head">Location</label>
                      <div className="col-md-12 mb-4">
                        <MultiSelect
                          id="countryStates"
                          options={countryStates}
                          defaultText="Select State"
                          onClose={(selectedIds: string[]) =>
                            onMultiSelectChange(selectedIds, "state")
                          }
                          selectedValues={
                            selectedStateValue ? selectedStateValue : []
                          }
                          hasError
                          errorText=""
                          searchable
                        />
                      </div>
                      <label className="col-sm-4 col-form-head">Sector</label>
                      <div className="col-md-12 mb-4">
                        <MultiSelect
                          id="countryStates"
                          options={sectorDetails}
                          defaultText="Select Industry"
                          onClose={(selectedIds: string[]) =>
                            onMultiSelectChange(selectedIds, "sector")
                          }
                          selectedValues={
                            selectedSectorValue ? selectedSectorValue : []
                          }
                          hasError
                          errorText=""
                          searchable
                        />
                      </div>
                      {/* <label className="col-sm-4 col-form-head">Legal Entity</label>
                                            <div className="col-md-12 mb-4">
                                                <MultiSelect
                                                    id="countryStates"
                                                    options={entityDetails}
                                                    defaultText="Select Industry"
                                                    onClose={(selectedIds: string[]) =>
                                                        onMultiSelectChange(selectedIds, 'entity')
                                                    }
                                                    selectedValues={
                                                        selectedEntityValue ? selectedEntityValue : []
                                                    }
                                                    hasError
                                                    errorText=""
                                                    searchable
                                                />
                                            </div> */}
                      <label className="col-sm-12 col-form-head">
                        Types of Funds Required
                      </label>
                      <div className="col-md-12 mb-4">
                        <div className="select-custom">
                          <select
                            className="form-control input-height"
                            aria-label="Select Fund Type"
                            value={fundingType}
                            onChange={(e: any) =>
                              setFundingType(e.target.value)
                            }
                          >
                            <option >Select</option>
                            {/* selected */}
                            <option value="funding_grant">Grant</option>
                            <option value="funding_debenture">Debenture</option>
                            <option value="funding_debt">Debt</option>
                          </select>
                        </div>
                      </div>
                      <label className="col-sm-12 col-form-head">
                        Date Of Submission
                      </label>
                      <div className="col-md-12 mb-4">
                        <Calendar
                          id="submissionDate"
                          name="submissionDate"
                          className="form-control input-height"
                          format="dd/MM/yyyy"
                          selectedDate={filterDate}
                          onDateChange={(date: Date, field: string) =>
                            handleDateChange(date, "submissionDate")
                          }
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <div className="row modal-row">
                        <div className="col-md-6 text-center">
                          <button
                            className="btn btn-sisfs btn-transparent-primary"
                            data-dismiss="modal"
                            onClick={resetFilter}
                          >
                            RESET ALL
                          </button>
                        </div>
                        <div className="col-md-6 text-left">
                          <button
                            className="tertiary  btn-yellow-primary"
                            data-dismiss="modal"
                            onClick={applyFilter}
                          >
                            APPLY FILTER
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* schedule a meeting tab */}
              <div
                className="modal fade"
                id="scheduleMeeting"
                role="dialog"
                aria-labelledby="exampleModalLabel1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-slideout modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header modal-header-bottom pr-5">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => (
                          setTimeValidation(false),
                          setTimeValidationCurrentTime(false),
                          setLinkValidation(false)
                        )}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body pl-5 pr-5 pt-2">
                      <div className="popup-head mb-5 ml-3">
                        <div className="main-heading">Schedule a Meeting</div>
                        <div className="count-text">
                          {checkedArray.length} Startups Selected
                        </div>
                      </div>

                      <label className="col-sm-4 col-form-head">
                        Meeting Type
                      </label>
                      <div className="col-md-12 mb-4">
                        <div className="select-custom">
                          <select
                            className="form-control input-height"
                            aria-label="Select Entity Type"
                            onChange={handleOnChange}
                          >
                            {tableHeading == "Applications Selected" ? (
                              <option value="2">
                                Performance Review Meeting
                              </option>
                            ) : null}
                            {tableHeading == "Applications to be Reviewed" ? (
                              <option value="1">Startup Selection</option>
                            ) : null}
                          </select>
                        </div>
                      </div>
                      <label className="col-sm-4 col-form-head">
                        Date & Time
                      </label>
                      <div className="col-md-6 mb-4">
                        <Calendar
                          id="registrationDate"
                          name="registrationDate"
                          className="form-control input-height"
                          format="dd/MM/yyyy"
                          selectedDate={
                            selectedDateControl
                              ? selectedDateControl
                              : new Date()
                          }
                          onDateChange={(date: Date, field: string) =>
                            handleDateChange(date, field)
                          }
                          // minDate={new Date()}
                        />
                      </div>
                      <div className="row pl-3">
                        <div className="col-md-6">
                          <label className="col-form-head">From Time</label>
                          <input
                            type="time"
                            value={fromTime}
                            name="fromTime"
                            className="form-control input-height"
                            onChange={onTimeChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-head">To Time</label>
                          <input
                            type="time"
                            value={toTime}
                            name="toTime"
                            className="form-control input-height"
                            onChange={onTimeChange}
                          />
                        </div>
                      </div>
                      <div className="row text-left pl-4 mb-5">
                        {timeValidation == true ? (
                          <label className="error-message">
                            From time greater than To time
                          </label>
                        ) : null}
                        {timeValidationCurrentTime == true ? (
                          <label className="error-message">
                            Meeting can't be scheduled for past time
                          </label>
                        ) : null}
                      </div>
                      <label className="col-sm-4 col-form-head">
                        Meeting Link
                      </label>
                      <div className="col-md-12 mb-4">
                        <input
                          type="text"
                          id="meeting_link"
                          name="meeting_link"
                          className="form-control input-height"
                          onChange={(e: any) => setMeetingLink(e.target.value)}
                        />
                        <div className="row text-left pl-3">
                          {linkValidation == true ? (
                            <label className="error-message">
                              Meeting Link is required
                            </label>
                          ) : null}
                        </div>
                      </div>

                      <div className="row pl-3">
                        <div className="col-md-6">
                          <button
                            className="btn btn-sisfs btn-transparent-primary full-width"
                            data-dismiss="modal"
                            onClick={() => (
                              setTimeValidation(false),
                              setTimeValidationCurrentTime(false),
                              setLinkValidation(false)
                            )}
                          >
                            CANCEL
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            className={
                              isDisabled
                                ? "tertiary  btn-yellow-primary full-width custom-disabled"
                                : "tertiary  btn-yellow-primary full-width"
                            }
                            disabled={isDisabled}
                            onClick={scheduleMeetingFunction}
                          >
                            SCHEDULE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* quick edit popup */}
              <div
                className="modal fade"
                id="quickEdit"
                role="dialog"
                aria-labelledby="exampleModalLabel1"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-slideout modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header modal-header-bottom pr-5">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setSelectFlag(true)}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body pl-5 pr-5 pt-5">
                      <div className="popup-head mb-5 ml-2">
                        <div className="main-heading">
                          {quickEditPopupData.incubator_name}
                        </div>
                        <div className="count-text">
                          {"No: " + quickEditPopupData.application_id}
                        </div>
                      </div>

                      <label className="col-sm-8 col-form-head">
                        Total Grant Approved (
                        {quickEditPopupData.no_of_tranches} Tranches)
                      </label>
                      {showEditTranche ? (
                        <span
                          className="col-sm-4 text-left view-all"
                          data-dismiss="modal"
                          onClick={() =>
                            handleRowChange(
                              quickEditPopupData.application_id,
                              0,
                              0,
                              0,
                              0, 
                              "",
                              0                             
                            )
                          }
                        >
                          Edit Tranche
                        </span>
                      ) : null}
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <input
                            type="number"
                            id="total_approved_amount"
                            name="total_approved_amount"
                            className="form-control input-height"
                            value={quickEditPopupData.total_approved_amount}
                            onChange={handlePopupChange}
                            disabled={selectFlag}
                          />
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all">View</span>
                </div> */}
                      </div>

                      <label className="col-sm-8 col-form-head">
                        No. of Tranches
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <input
                            type="number"
                            aria-label="Select State"
                            id="no_of_tranches"
                            name="no_of_tranches"
                            className="form-control input-height"
                            value={quickEditPopupData.no_of_tranches}
                            onChange={handlePopupChange}
                            disabled={selectFlag}
                          />
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all" >Edit</span>
                </div> */}
                      </div>

                      <label className="col-sm-8 col-form-head">
                        Application Status
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <div className="select-custom">
                            <select
                              className="form-control input-height"
                              aria-label="Select State"
                              id="status_id"
                              name="status_id"
                              value={quickEditPopupData.application_status}
                              onChange={handlePopupChange}
                            >
                              {applicationStatus.map(({ label, value }) =>
                                label !== "Draft" ? (
                                  <option key={label} value={value}>
                                    {label}
                                  </option>
                                ) : null
                              )}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-4 mb-4">
                  <span className="view-all" onClick={() => setSelectFlag(false)}>Edit</span>
                </div> */}
                      </div>
                      <label className="col-sm-8 col-form-head">
                        Date Of Evaluation
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <fieldset disabled={selectFlag}>
                            <Calendar
                              id="registrationDate"
                              name="registrationDate"
                              className="form-control input-height"
                              format="dd/MM/yyyy"
                              selectedDate={
                                quickEditPopupData.date_of_evaluation
                              }
                              onDateChange={(date: Date, field: string) =>
                                handlePopupDateChange(date, field)
                              }
                              minDate={new Date()}
                            />
                          </fieldset>
                        </div>
                        {/* <div className="col-md-3 text-left mb-4">
                  <span className="view-all">View Details</span>
                </div> */}
                      </div>
                      <label className="col-sm-8 col-form-head">
                        Comments, if any
                      </label>
                      <div className="row pl-3">
                        <div className="col-md-11 mb-4">
                          <textarea
                            value={quickEditPopupData.application_comments}
                            className="form-control textarea-height"
                            name="popup_comments"
                            onChange={handlePopupChange}
                          />
                        </div>
                      </div>
                      <div className="row pl-3">
                        <div className="col-md-6">
                          <button
                            className="btn btn-sisfs btn-transparent-primary full-width"
                            data-dismiss="modal"
                          >
                            CANCEL
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            className={
                              isDisabled
                                ? "tertiary  btn-yellow-primary full-width custom-disabled"
                                : "tertiary  btn-yellow-primary full-width"
                            }
                            disabled={isDisabled}
                            onClick={quickEditCall}
                          >
                            UPDATE
                          </button>
                        </div>
                      </div>

                      {/* <div className="row pl-5">
                <button
                  className="btn btn-sisfs btn-transparent-primary"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
                <button
                  className="tertiary  btn-yellow-primary ml-3"
                  onClick={scheduleMeetingFunction}
                >
                  SCHEDULE
                </button>
              </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {showIncubatorSuccessModal && (
                // <FormSubmissionSuccess data-toggle="modal" data-target="#FormSubmissionSuccess"// />
                // <>
                //   <div className="modal-backdrop fade show"></div>

                //   <div
                //     className="modal align-middle modal-sisfs d-block"
                //     id="FormSubmissionSuccess"
                //   >
                //     <div className="modal-dialog modal-dialog-centered modal-md">
                //       <div className="modal-content">
                //         <div className="modal-body text-center">
                //           <i className="fa fa-check-circle-o"></i>
                //           <h3 className="modal-message">Thank You!</h3>
                //           <div className="modal-text">
                //             Your Meeting Has been Scheduled
                //                         </div>
                //           <div className="modal-action">
                //             <button className="btn btn-sisfs btn-yellow-primary" onClick={dismissModal}>
                //               Ok!!
                //                         </button>
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // </>
                <ConfirmationDialog
                  headerText={dialogData.header}
                  bodyText={dialogData.text}
                  onDialogClose={dismissModal}
                />
              )}
              {showIncubatorFailureModal && (
                // <FormSubmissionSuccess data-toggle="modal" data-target="#FormSubmissionSuccess"// />
                // <>
                //   <div className="modal-backdrop fade show"></div>
                //   <div
                //     className="modal align-middle modal-sisfs d-block"
                //     id="FormSubmissionError"
                //   >
                //     <div className="modal-dialog modal-dialog-centered modal-md">
                //       <div className="modal-content">
                //         <div className="modal-body text-center">
                //         <img
                //       src={error}
                //       className="search mb-2"
                //       alt="search"

                //     />
                //           <h3 className="modal-message">
                //             {failDialogData.header}
                //                       </h3>
                //           <h3 className="modal-text">
                //           {failDialogData.text}
                //                       </h3>
                //           <div className="modal-action">
                //             <button className="btn btn-sisfs btn-yellow-primary" onClick={() => setShowIncubatorFailureModal(false)}>
                //               OK!
                //                       </button>
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // </>
                <ConfirmationDialog
                  headerText={failDialogData.header}
                  bodyText={failDialogData.text}
                  onDialogClose={() => setShowIncubatorFailureModal(false)}
                  iconClass="test"
                />
              )}
              {showConfirmationBox && (
                <>
                  <div className="modal-backdrop fade show"></div>
                  <div
                    className="modal align-middle modal-sisfs d-block"
                    id="FormSubmissionError"
                  >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                      <div className="modal-content">
                        <div className="modal-body text-center">
                          {/* <img
               src={error}
               className="search mb-2"
               alt="search"

             /> */}
                          <h3 className="modal-message mt-2">
                            {confirmationDialogData.header}
                          </h3>
                          <h3 className="modal-text">
                            {confirmationDialogData.text}
                          </h3>
                          <div className="modal-action mt-2">
                            <button
                              className="btn btn-sisfs btn-transparent-primary"
                              onClick={() => setShowConfirmationBox(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className={
                                isDisabled
                                  ? "btn btn-sisfs btn-yellow-primary ml-2 custom-disabled"
                                  : "btn btn-sisfs btn-yellow-primary ml-2"
                              }
                              disabled={isDisabled}
                              onClick={finalSchedule}
                            >
                              Schedule Anyway
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* edit success Modal */}
              {showEditSuccessModal && (
                // <FormSubmissionSuccess data-toggle="modal" data-target="#FormSubmissionSuccess"// />
                <>
                  <div className="modal-backdrop fade show"></div>

                  <div
                    className="modal align-middle modal-sisfs d-block"
                    id="FormSubmissionSuccess"
                  >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                      <div className="modal-content">
                        <div className="modal-body text-center">
                          <i className="fa fa-check-circle-o"></i>
                          <h3 className="modal-message">Thank You!</h3>
                          <div className="modal-text">
                            Application has been Updated Successfully
                          </div>
                          <div className="modal-action">
                            <button
                              className="btn btn-sisfs btn-yellow-primary"
                              onClick={dismissModal}
                            >
                              Ok!!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* edit fail modal */}
              {showEditFailureModal && (
                // <FormSubmissionSuccess data-toggle="modal" data-target="#FormSubmissionSuccess"// />
                <>
                  <div className="modal-backdrop fade show"></div>
                  <div
                    className="modal align-middle modal-sisfs d-block"
                    id="FormSubmissionError"
                  >
                    <div className="modal-dialog modal-dialog-centered modal-md">
                      <div className="modal-content">
                        <div className="modal-body text-center">
                          {/* <i className="fa fa-times-circle-o"></i> */}
                          <h3 className="modal-message message-orange">
                            Oops! Something is Wrong
                          </h3>
                          <br />
                          <h3 className="modal-message message-orange">
                            Please Try Again!!!
                          </h3>
                          <div className="modal-action">
                            <button
                              className="btn btn-sisfs btn-yellow-primary"
                              onClick={dismissModal}
                            >
                              OK!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StartupListContainer;
